import React from 'react';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import ButtonComponent from './ButtonMC';
import { SIDEBAR_ACTIONS } from '../../constants/actionsConstants';
import { cleanObject } from '../../util/ObjectUtils';

const ButtonOpenFiltersMC = ({ asideFilters, activeQueryParams, filterDefaults = {} }) => {
  const dispatch = useDispatch();

  // Obtener las keys de los filtros reales (asideFilters)
  const filterKeys = (asideFilters || []).map((filter) => filter.key);
  const durationComparisonKeys = (asideFilters || [])
    .filter((f) => f.type === 'duration-comparison')
    .map((f) => f.key);

  const isActiveFilterParam = (key) => {
    const excludedParams = ['page', 'order_by', 'tab', 'q'];
    if (excludedParams.includes(key)) return false;
    if (filterKeys.includes(key)) return true;
    if (key.startsWith('q[')) return true;
    if (durationComparisonKeys.some((filterKey) => key.startsWith(`${filterKey}_`))) return true;
    return false;
  };

  const activeFilters = cleanObject(
    Object.fromEntries(
      Object.entries(activeQueryParams || {}).filter(([key]) => isActiveFilterParam(key))
    )
  );

  const openFiltersSidebar = () => {
    dispatch({
      type: SIDEBAR_ACTIONS.OPEN_SIDEBAR,
      payload: {
        componentKey: 'FiltersSidebar',
        props: {
          asideFilters,
          filterDefaults
        }
      }
    });
  };

  return (
    <div className="tw-wrapper tw-relative">
      {!isEmpty(activeFilters) && (<FilterIndicator />)}
      <ButtonComponent
        icon="filter-3-fill"
        variant="GRAY"
        onClick={openFiltersSidebar}
        outlined
      />
    </div>
  );
};

const FilterIndicator = () => (
  <div className="tw-absolute tw-right-1.5 tw-top-1.5 tw-w-2 tw-h-2 tw-rounded-full tw-bg-red-500" />
);

export default ButtonOpenFiltersMC;
